var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1016_9568)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 6,
    width: 49,
    height: 47,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4612 48.9742H40.8599V35.6368C40.8599 32.4564 40.8025 28.3622 36.3863 28.3622C31.9064 28.3622 31.221 31.8274 31.221 35.4053V48.9733H22.6196V21.5462H30.8769V25.2944H30.9925C31.8189 23.8954 33.013 22.7446 34.4477 21.9644C35.8824 21.1842 37.5039 20.8039 39.1396 20.864C47.8574 20.864 49.4648 26.5418 49.4648 33.9282L49.4612 48.9742ZM12.9145 17.7972C11.9272 17.7973 10.9621 17.5076 10.1412 16.9647C9.32023 16.4218 8.68037 15.65 8.30242 14.747C7.92446 13.844 7.82541 12.8503 8.01783 11.8915C8.21025 10.9328 8.6855 10.0521 9.38345 9.36074C10.0814 8.66942 10.9707 8.19855 11.9389 8.00768C12.9071 7.81681 13.9107 7.9145 14.8229 8.28841C15.735 8.66232 16.5147 9.29565 17.0633 10.1083C17.6119 10.921 17.9049 11.8765 17.905 12.854C17.9052 13.503 17.7761 14.1457 17.5254 14.7454C17.2747 15.345 16.9071 15.8899 16.4437 16.349C15.9803 16.808 15.4301 17.1721 14.8245 17.4206C14.219 17.6691 13.5699 17.797 12.9145 17.7972ZM17.2151 48.9742H8.60483V21.5462H17.2151V48.9742ZM53.7493 0.00361085H4.28268C3.15992 -0.00893464 2.07802 0.420389 1.27479 1.19724C0.471563 1.97409 0.012726 3.03491 -0.000976562 4.14659V53.3292C0.012257 54.4415 0.470825 55.503 1.27402 56.2807C2.07722 57.0583 3.15937 57.4885 4.28268 57.4767H53.7493C54.8749 57.4906 55.96 57.0617 56.7664 56.2841C57.5728 55.5064 58.0344 54.4437 58.05 53.3292V4.14305C58.0339 3.02916 57.572 1.96713 56.7656 1.1903C55.9592 0.413467 54.8743 -0.01463 53.7493 6.08151e-05",
    fill: "#0A66C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1016_9568"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.fc22e20181fd96a6df0d57b49e41c754.svg";
export { ForwardRef as ReactComponent };